/**
* @author Camilo
* @since  08/11/2017
**/

import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import { AuthService } from './auth.service';
import { MatSnackBar } from '@angular/material';
import { InfoSesion } from './../Global/InfoSesion.model';
import { ServiciosGenerales } from '../Servicios/ServiciosGenerales.service';

@Injectable()
export class RoleGuardService implements CanActivate {

  public ocultar: boolean= false;
	public mensaje: string="";

  constructor(public auth: AuthService, public serviciosGenerales:ServiciosGenerales, public router: Router, public snackBar: MatSnackBar) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {


    const formulario = route.data.formulario;


    if (this.auth.isAuthenticated() == false){
      this.auth.clearSession(this.serviciosGenerales);
      this.router.navigate(['']);
      this.openSnackBarEspecial("La sesión ha caducado. Por favor ingrese nuevamente", "X");
   

      return false;
    }

    if (this.auth.isTokenExpired()){
      
      this.auth.clearSession(this.serviciosGenerales);
      this.router.navigate(['']);
      this.openSnackBarEspecial("La sesión expiró", "X");
      
      
      return false;
    }

    
    if(formulario.trim() != 'dashboard'){
      if (this.auth.getInfoToken()[formulario] == undefined || this.auth.getInfoToken()[formulario] == null || this.auth.getInfoToken()[formulario] == ''){
        
        //this.auth.clearSession();
        //this.router.navigate(['']);
        this.openSnackBarEspecial("No tiene permiso para usar esta opción", "X");
        
        
        return false;
      }
    }
    this.auth.setActivo(formulario);
    
    /**
    * ADD @author Camilo
    *     @since  03/01/2018
    **/
    let info:InfoSesion = this.auth.getInfoSesion();
    info.nombreFormularioActual = route.data.nombreFormulario;
    this.auth.setInfoSesion(info);

  /*  let x = {
      nombreParametro : 'nombreFormularioActual',
      valorParametro : info.nombreFormularioActual
    }

    this.serviciosGenerales.post('t/ap', x).subscribe(r=>{
      this.auth.setToken(r.t)
    });
*/
    return true;
  }


  openSnackBar(message: string, action: string)
  {
    this.snackBar.open(message, action, {
      duration: 20000
    });
  }
  openSnackBarEspecial(message: string, action: string) {
    let snackBarRef =  this.snackBar.open(message, action);

    snackBarRef.onAction().subscribe(() => {
       
        this.ocultar = false;
        this.mensaje = "";
    });
    
    let shand = document.getElementsByClassName('mat-snack-bar-container') as HTMLCollectionOf<HTMLElement>;        
    
    if (shand.length != 0) {
            for (let i=0;i<shand.length;i++){
            shand[i].style.backgroundColor = "rgb(255 204 214)";
            }
        }
}

}


// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/Seguridad/role-guard.service.ts